import { graphql } from 'graphql/hoopla/generated'

export const QueryGetLibraryBrandingQueryDocument = graphql(/* gql_hoopla */ `
  query GetLibraryBranding {
    libraryBranding {
      baseColor
      logoFileName
    }
  }
`)

export const QueryGetLibrarySettings = graphql(/* gql_hoopla */ `
  query GetLibrarySettings {
    patron {
      library {
        settings {
          defaultAvailabilityFilter
          enableEST
          enableHolds
          enablePPU
          enableTitleRequests
          enabled
        }
      }
    }
  }
`)

export const QueryGetLibrarySplashConfigQueryDocument =
  graphql(/* gql_hoopla */ `
    query Patron {
      patron {
        library {
          splashConfig {
            textColor
            seconds
            imageName
            displayText
            backgroundColor
          }
        }
      }
    }
  `)

export const QueryGetEnabledAutoLend = graphql(/* gql_hoopla */ `
  query GetEnabledAutoLend {
    patron {
      library {
        settings {
          enableAutoLend
        }
      }
    }
  }
`)

export const QueryGetEnabledEmails = graphql(/* gql_hoopla */ `
  query GetEnabledEmails {
    patron {
      library {
        settings {
          enableBorrowEmails
          enableGeneralEmails
        }
      }
    }
  }
`)

export const QueryGetLibrary = graphql(/* gql_hoopla */ `
  query GetLibrary {
    patron {
      library {
        id
        country {
          id
        }
        city
        name
      }
    }
  }
`)

export const QueryGetLibraryCardUrl = graphql(/* gql_hoopla */ `
  query GetLibraryCardUrl {
    patron {
      library {
        settings {
          libraryCardUrl
        }
      }
    }
  }
`)

export const QueryGetLibraryCirculationLimits = graphql(/* gql_hoopla */ `
  query GetLibraryCirculationStats {
    patron {
      library {
        settings {
          maxConcurrentEstCirculations
          maxPPUCirculationsPerMonth
        }
      }
    }
  }
`)

export const QueryGetLibraryCountryData = graphql(/* gql_hoopla */ `
  query GetLibraryCountry {
    patron {
      library {
        country {
          id
          abbrev
          name
        }
      }
    }
  }
`)

export const QueryGetLibraryHoldReservationHours = graphql(/* gql_hoopla */ `
  query GetLibraryHoldReservationHours {
    patron {
      library {
        settings {
          holdReservationHours
        }
      }
    }
  }
`)

export const QueryGetLibraryPinRequired = graphql(/* gql_hoopla */ `
  query GetLibraryPinRequired {
    patron {
      library {
        settings {
          pinRequired
        }
      }
    }
  }
`)
